import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Breadcrumb from '../../components/Breadcrumb';

export default function ProjectsPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Project data
  const projects = [
    {
      id: 1,
      category: 'Residential',
      title: 'Modern Home Attic Insulation',
      location: 'Foothills Area',
      description: 'Complete attic spray foam installation for a 2,400 sq ft home, achieving exceptional thermal protection and energy savings.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/ab328d9d68a2a91f3ff829b424941413.jpeg',
      alt: 'Residential attic spray foam insulation project',
      details: {
        size: '2,400 sq ft',
        duration: '2 days',
        savings: '45% energy reduction'
      }
    },
    {
      id: 2,
      category: 'Commercial',
      title: 'Warehouse Roof Insulation',
      location: 'Business Park',
      description: 'Large-scale commercial warehouse project with closed-cell foam application on metal roof deck, dramatically reducing cooling costs.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/fe8e87812d60d0ea5249d33f08fe26b9.jpeg',
      alt: 'Commercial warehouse spray foam insulation project',
      details: {
        size: '15,000 sq ft',
        duration: '5 days',
        savings: '52% cooling cost reduction'
      }
    },
    {
      id: 3,
      category: 'Residential',
      title: 'New Construction Home',
      location: 'East Valley',
      description: 'Complete spray foam insulation for new home construction, providing superior air sealing and maximum energy efficiency.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/85338fa3c50b368ef442f66370fdb19b.jpeg',
      alt: 'New construction residential spray foam project',
      details: {
        size: '3,200 sq ft',
        duration: '3 days',
        savings: '48% energy reduction'
      }
    },
    {
      id: 4,
      category: 'Commercial',
      title: 'Office Building Renovation',
      location: 'Main Street',
      description: 'Commercial office building insulation upgrade, improving comfort and reducing operational costs for tenants.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/b76cf241ef57e7181749e4c335816dd7.jpeg',
      alt: 'Commercial office building insulation project',
      details: {
        size: '8,500 sq ft',
        duration: '4 days',
        savings: '41% HVAC cost reduction'
      }
    },
    {
      id: 5,
      category: 'Residential',
      title: 'Crawl Space Encapsulation',
      location: 'West Side',
      description: 'Complete crawl space insulation and moisture barrier installation, protecting home foundation and improving air quality.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/94bbd696513978aab0c6c2a15252b6d2.jpeg',
      alt: 'Residential crawl space insulation project',
      details: {
        size: '1,800 sq ft',
        duration: '2 days',
        savings: '35% energy reduction'
      }
    },
    {
      id: 6,
      category: 'Commercial',
      title: 'Retail Store Renovation',
      location: 'North County',
      description: 'Retail space insulation upgrade for improved customer comfort and reduced operating expenses.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/92ed35fcaf572a7d574fa0ea74049699.jpeg',
      alt: 'Commercial retail store insulation project',
      details: {
        size: '5,200 sq ft',
        duration: '3 days',
        savings: '38% energy cost reduction'
      }
    },
    {
      id: 7,
      category: 'Residential',
      title: 'Metal Building Home',
      location: 'South Area',
      description: 'Specialty spray foam application for metal building residential conversion, preventing condensation and maximizing comfort.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/42d4837eb8665fc5e913ec7d8c6bd364.jpeg',
      alt: 'Residential metal building insulation project',
      details: {
        size: '2,800 sq ft',
        duration: '3 days',
        savings: '50% energy reduction'
      }
    },
    {
      id: 8,
      category: 'Commercial',
      title: 'Restaurant Kitchen',
      location: 'Downtown District',
      description: 'Commercial kitchen insulation meeting health code requirements while dramatically reducing refrigeration costs.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/aff340e018260f55e97e328065525503.jpeg',
      alt: 'Commercial restaurant kitchen insulation project',
      details: {
        size: '3,500 sq ft',
        duration: '2 days',
        savings: '44% cooling cost reduction'
      }
    },
    {
      id: 9,
      category: 'Residential',
      title: 'Garage Conversion',
      location: 'Central Area',
      description: 'Garage to living space conversion with complete spray foam insulation for year-round comfort.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/bb39c1a77ef8efc4e23dc892af8d7681.jpeg',
      alt: 'Residential garage conversion insulation project',
      details: {
        size: '600 sq ft',
        duration: '1 day',
        savings: '42% energy reduction'
      }
    }
  ];

  // Filter projects based on selected category
  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  useEffect(() => {
    // Page title
    document.title = 'Spray Foam Projects Yuma AZ | Completed Installations';

    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'View completed spray foam insulation projects in Yuma, AZ. Residential & commercial installations with real energy savings results. Free quotes. Call (928) 427-8140.'
      );
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + '/projects');

    // Geo-location tags
    const metaTags = [
      { name: 'geo.region', content: 'US-AZ' },
      { name: 'geo.placename', content: 'Yuma' },
      { name: 'geo.position', content: '32.6927;-114.6277' },
      { name: 'ICBM', content: '32.6927, -114.6277' },
    ];
    metaTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Spray Foam Projects Yuma AZ | Completed Installations' },
      {
        property: 'og:description',
        content: 'View our completed spray foam insulation projects in Yuma, AZ. Residential & commercial installations.'
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.origin + '/projects' },
      {
        property: 'og:image',
        content: 'https://public.readdy.ai/ai/img_res/92bcbec1b4a69f630f429742131c4147.jpg'
      }
    ];
    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', tag.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Spray Foam Projects Yuma AZ | Completed Installations' },
      {
        name: 'twitter:description',
        content: 'View our completed spray foam insulation projects in Yuma, AZ. See real results.'
      },
      {
        name: 'twitter:image',
        content: 'https://readdy.ai/api/search-image?query=Professional%20spray%20foam%20insulation%20installation%20showcase%20with%20completed%20residential%20and%20commercial%20projects%20clean%20modern%20spaces%20with%20excellent%20thermal%20protection%20and%20energy%20efficiency%20results&width=1200&height=630&seq=twitter-projects-001&orientation=landscape'
      }
    ];
    twitterTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Last-modified tag
    let lastModified = document.querySelector('meta[name="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('name', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    // Breadcrumb schema
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: window.location.origin + '/'
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Projects',
          item: window.location.origin + '/projects'
        }
      ]
    };

    let breadcrumbScript = document.querySelector('script[data-schema="breadcrumb-projects"]');
    if (!breadcrumbScript) {
      breadcrumbScript = document.createElement('script');
      breadcrumbScript.setAttribute('type', 'application/ld+json');
      breadcrumbScript.setAttribute('data-schema', 'breadcrumb-projects');
      document.head.appendChild(breadcrumbScript);
    }
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Breadcrumb items={[{ label: 'Home', href: '/' }, { label: 'Projects' }]} />

      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Completed <strong>Spray Foam Projects</strong> in Yuma AZ
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8">
            See real results from our work across <strong>Yuma County, Arizona</strong>. From <a href="/residential-insulation-yuma" className="text-blue-900 hover:text-blue-700 font-semibold underline">residential homes</a> to large commercial facilities, we deliver quality solutions that <strong>reduce energy costs</strong> and improve comfort throughout the region.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <div className="bg-white px-6 py-4 rounded-lg shadow-md">
              <div className="text-3xl font-bold text-blue-900">127+</div>
              <div className="text-sm text-gray-600">Completed Projects</div>
            </div>
            <div className="bg-white px-6 py-4 rounded-lg shadow-md">
              <div className="text-3xl font-bold text-emerald-600">42%</div>
              <div className="text-sm text-gray-600">Avg. Energy Savings</div>
            </div>
            <div className="bg-white px-6 py-4 rounded-lg shadow-md">
              <div className="text-3xl font-bold text-blue-900">100%</div>
              <div className="text-sm text-gray-600">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-gray-50 border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Filter Projects by Type
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {['All', 'Residential', 'Commercial'].map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-blue-900 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Recent Insulation Installations
          </h2>
          
          {/* Mobile: Swipeable hint */}
          <div className="md:hidden text-center text-sm text-gray-500 mb-4">
            Swipe to see more projects →
          </div>

          {/* Mobile: Horizontal scroll, Desktop: Grid */}
          <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 flex md:flex-none overflow-x-auto md:overflow-x-visible gap-4 pb-4 snap-x snap-mandatory scrollbar-hide">
            {filteredProjects.map((project) => (
              <div key={project.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex-shrink-0 w-[85vw] md:w-auto snap-center">
                <div className="relative w-full h-64">
                  <img
                    src={project.image}
                    alt={project.alt}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4 bg-blue-900 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {project.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                  <div className="flex items-center text-gray-600 text-sm mb-3">
                    <i className="ri-map-pin-line mr-2"></i>
                    {project.location}
                  </div>
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    {project.description}
                  </p>
                  <div className="border-t border-gray-200 pt-4 space-y-2">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Size:</span>
                      <span className="font-semibold text-gray-900">{project.details.size}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Duration:</span>
                      <span className="font-semibold text-gray-900">{project.details.duration}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Results:</span>
                      <span className="font-semibold text-emerald-600">{project.details.savings}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-blue-900 to-blue-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-lg text-blue-100 mb-8">
            Join our list of satisfied customers across the area. Get a free quote and see how much you can save on your <strong>energy bills</strong>. Our <a href="/about-yuma-insulation" className="text-white hover:text-blue-200 font-semibold underline">experienced team</a> serves both residential and <a href="/commercial-insulation-yuma" className="text-white hover:text-blue-200 font-semibold underline">commercial clients</a> throughout Yuma County.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:9284278140"
              className="inline-flex items-center px-8 py-4 bg-white text-blue-900 font-bold rounded-lg hover:bg-blue-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Call (928) 427-8140
            </a>
            <a
              href="/insulation-services-arizona"
              className="inline-flex items-center px-8 py-4 bg-blue-800 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-list-check mr-2 text-xl"></i>
              View All Services
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
